import { inject, Injectable } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import {
  SOFTLINE_API_DOCUMENT_NOTE_BY_ID,
  SOFTLINE_API_DOCUMENT_NOTES,
} from '../documents.api';
import { DocumentNote, DocumentNoteRequest } from '../types/document-note';

@Injectable()
export class DocumentNoteRepository {
  private readonly dataAccess = inject(ApiDataAccess);

  getAll(id: string): Promise<DocumentNote[]> {
    return this.dataAccess.get<DocumentNote[]>({
      path: SOFTLINE_API_DOCUMENT_NOTES,
      pathParams: { id },
    });
  }

  create(id: string, body: DocumentNoteRequest): Promise<DocumentNote> {
    return this.dataAccess.create<DocumentNoteRequest, DocumentNote>(
      { path: SOFTLINE_API_DOCUMENT_NOTES, pathParams: { id } },
      body
    );
  }

  update(id: string, noteId: string, body: DocumentNoteRequest): Promise<DocumentNote> {
    return this.dataAccess.patch<DocumentNoteRequest, DocumentNote>(
      { path: SOFTLINE_API_DOCUMENT_NOTE_BY_ID, pathParams: { id, noteId } },
      body
    );
  }

  delete(id: string, noteId: string): Promise<void> {
    return this.dataAccess.delete<void>({
      path: SOFTLINE_API_DOCUMENT_NOTE_BY_ID,
      pathParams: { id, noteId },
    });
  }
}
